const updates = [
  { date: '2026-07-30', tag: '新片上线', title: '《星际迷航：新纪元》高清版已上线', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '2026-07-29', tag: '剧集更新', title: '《长安十二时辰》第二季第8集更新', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '2026-07-28', tag: '综艺上新', title: '《乘风破浪的姐姐》第六季最新期上线', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '2026-07-27', tag: '动漫更新', title: '《咒术回战》第三季第15话已同步', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '2026-07-26', tag: '新片上线', title: '韩国悬疑大片《迷雾追踪》4K版发布', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '2026-07-25', tag: '剧集更新', title: '《繁花》导演剪辑版全集上线', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '2026-07-24', tag: '片库扩充', title: '新增200+部经典好莱坞电影资源', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '2026-07-23', tag: '动漫更新', title: '《鬼灭之刃》锻刀村篇全集上线', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '2026-07-22', tag: '综艺上新', title: '《脱口秀大会》第七季第3期更新', tagColor: 'bg-secondary-100 text-secondary-700' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2 text-center">
          最新更新
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">影视资源每日同步更新，精彩内容不再错过</p>
        <div className="max-w-[800px] mx-auto">
          {updates.map((u, i) => (
            <div
              key={i}
              className="flex items-start gap-4 py-4 border-b border-background-200/70 last:border-0 group hover:bg-background-50/80 px-3 -mx-3 rounded-lg transition-colors"
            >
              <span className="text-xs text-foreground-400 whitespace-nowrap mt-0.5 flex-shrink-0">{u.date}</span>
              <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap flex-shrink-0 ${u.tagColor}`}>
                {u.tag}
              </span>
              <span className="text-sm text-foreground-700 font-medium leading-snug group-hover:text-primary-500 transition-colors">
                {u.title}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}